import { NumberInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { WarehouseLocationsFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function WarehouseLocationsForm() {
	/** Context */
	const methods = useFormContext<WarehouseLocationsFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<NumberInput
				isRequired
				label={t("stock.warehouse_zone_shelf_size")}
				control={methods.control}
				name="shelfSize"
				min={0}
				max={99}
			/>
			<NumberInput
				isRequired
				label={t("stock.warehouse_zone_axis_size")}
				control={methods.control}
				name="axisSize"
				min={0}
				max={999}
			/>
			<NumberInput
				isRequired
				label={t("stock.warehouse_zone_floor_size")}
				control={methods.control}
				name="floorSize"
				min={0}
				max={999}
			/>
		</div>
	);
}
